export class Document {
    id: number;
    filename: string
    constructor(document?) {
        if (document) {
            this.id = document.id;
            this.filename = document.filename;
        }
    }
}
